var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.row[_vm.column.key]),callback:function ($$v) {_vm.$set(_vm.row, _vm.column.key, $$v)},expression:"row[column.key]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }